import type { PrivateEventCrewView } from '../../api/privateEvents';

import NotRecordedPill from './NotRecordedPill';

export default function ClientDealContact({ event }: { event: PrivateEventCrewView }) {
  const missing = (field: string) =>
    event.migrated ? <NotRecordedPill field={field} short /> : <span>—</span>;
  return (
    <div
      style={{
        fontSize: 11.5,
        color: 'var(--nb-muted)',
        marginTop: 2,
        display: 'flex',
        gap: 10,
        flexWrap: 'wrap',
      }}
    >
      {event.contactEmail ? <span>{event.contactEmail}</span> : missing('Email')}
      {event.contactPhone ? (
        <span className="nb-tabular">{event.contactPhone}</span>
      ) : (
        missing('Phone')
      )}
    </div>
  );
}
